<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('settings') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab :title="$t('site_settings')">
                <CRow>
                  <CCol col="12">
                    <div>
                      {{ $t('reservation_business_link') }}
                    </div>
                    <a :href="'https://'+site_config.market_code+'.rezerveto.ir'" target="_blank" id="business_link_div">
                      {{ 'https://'+site_config.market_code+'.rezerveto.ir' }}
                    </a>
                    <CButton size="sm" color="primary" @click="copy_business_link()">
                      <CIcon name="cil-clone"/>
                    </CButton>
                  </CCol>
                  <CCol col="12" md="6">
                    <CInput
                        v-model="site_config.title.title"

                        :label="$t('site_title')"
                        :placeholder="$t('site_title')"
                        vertical
                    />
                  </CCol>
                  <CCol col="12" md="6">
                    <CInput
                        v-model="site_config.title.description"
                        label="شعار شما"
                        vertical
                    />
                  </CCol>
                  <CCol col="12" md="6">
                    <CInput
                        v-model="site_config.title.address"
                        :label="$t('address')"
                        vertical
                    />
                  </CCol>
                  <CCol col="12" md="6">
                    <CInput
                        v-model="site_config.title.phone"
                        :label="$t('phone_no')"
                        vertical
                    />
                  </CCol>
<!--                  <CCol col="12" md="6">-->
<!--                    <CSelect-->
<!--                        :value.sync="selected_currency"-->
<!--                        :options="currencies"-->
<!--                        :label="$t('currency')"-->
<!--                        vertical-->
<!--                    />-->
<!--                  </CCol>-->
                  <CCol col="12" md="6">
                    <CSelect
                        :value.sync="close_reserve_time"
                        :options="close_reserve_time_list"

                        label="آخرین زمان رزرو وقت"
                        vertical
                    />
                  </CCol>

                </CRow>
                <CRow>
                  <CCol col="6" md="4">

                    <ImageSelector :label="$t('logo')"
                                   :media_id.sync="logo_file"
                                   default_archive="site"
                                   :multiple="false"
                                   :crop-scale="'1:1'"
                                   :crop-max-width="500"
                                   :crop-max-height="500"
                                   :convert-to-webp="true"
                                   :preview-image="site_config.logo"
                    />
                  </CCol>
<!--                  <CCol col="6" md="4">-->

<!--                    <ImageSelector :label="$t('browser_icon')"-->
<!--                                   :media_id.sync="favicon_file"-->
<!--                                   default_archive="site"-->
<!--                                   :crop-scale="'1:1'"-->
<!--                                   :crop-max-width="500"-->
<!--                                   :crop-max-height="500"-->
<!--                                   :convert-to-webp="true"-->
<!--                                   :preview-image="site_config.favicon"-->
<!--                    />-->
<!--                  </CCol>-->
                  <CCol col="12" md="4">

                    <ImageSelector :label="$t('cover_image')"
                                   :media_id.sync="cover_file"
                                   default_archive="site"
                                   :preview-image="site_config.cover"
                    />
                  </CCol>


                </CRow>
                <hr>

                <CButton @click="update_settings()" size="sm"
                         color="primary">
                  <CIcon name="cil-check-circle"/>
                  {{ $t('update') }}
                </CButton>
              </CTab>
<CTab title="لینک ها">
  <CRow>
    <CCol col="12">
      <CInput
          label="آی دی اینستاگرام"
          v-model="links.instagram"/>
    </CCol>
    <CCol col="12">
      <CInput
          label="آی دی تلگرام"
          v-model="links.telegram"/>
    </CCol>
    <CCol col="12">
      <CInput
          label="شماره واتساپ"
          v-model="links.whatsapp"/>
    </CCol>
    <CCol col="12">
      <CInput
          label="لوکیشن نقشه"
          v-model="links.location"/>
    </CCol>
  </CRow>

  <CButton @click="update_links()" size="sm"
           color="primary">
    <CIcon name="cil-check-circle"/>
    {{ $t('update') }}
  </CButton>
</CTab>
<CTab title="پیام های اعلان">
  <CRow>
    <CCol col="12">
      <CTextarea


          label="اعلان عمومی"
          v-model="notices.public_notice"/>
    </CCol>
    <CCol col="12">
      <CTextarea
          label="اعلان کنسلی"
          v-model="notices.cancel_notice"/>
    </CCol>

  </CRow>

  <CButton @click="update_notices()" size="sm"
           color="primary">
    <CIcon name="cil-check-circle"/>
    {{ $t('update') }}
  </CButton>
</CTab>
            </CTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CCardBody>

    </CCardBody>


  </div>

</template>

<script>
import axios from "axios";


// import the styles

export default {
  name: 'Login',
  components: {},
  data() {

    return {
      web_address: localStorage.getItem("web_address"),
      design: {},
      links: {},
      notices: {},
      payment_type: '',
      payment_time: '',
      payment_deposit_info: '',
      close_reserve_time:0,
      close_reserve_time_list: [{label: "بدون محدودیت", value: 0},{label: "نیم ساعت قبل", value: 30},{label: "یک ساعت قبل", value: 60},{label: "دو ساعت قبل", value: 120}],
      db_url: localStorage.getItem("api_address"),
      site_config: {},
      languages: [],
      vat: "0",
      google_analytics: "",
      cache_time: "",
      currencies: [],
      sms_templates: [],
      logo_file: null,
      logo_previewImage: null,
      favicon_file: null,
      cover_file: null,
      favicon_previewImage: null,
      right_icon: null,
      left_icon: null,
      selected_currency:0,
    }
  },
  mounted() {

    this.get_data();

  }, watch: {},
  methods: {
copy_business_link() {
  const text = document.getElementById('business_link_div').innerText;
var self  =this
  // استفاده از Clipboard API برای کپی کردن متن
  navigator.clipboard.writeText(text)
      .then(() => {
        // موفقیت‌آمیز
       var res={data: {error: 0, msg: "لینک کپی شد"}}
        self.$root.modal_component.show_api_response_modals(res);
      })
      .catch(err => {
        // خطا
        var res={data: {error: 0, msg: "خطا در کپی لینک"}}
        self.$root.modal_component.show_api_response_modals(res);

      });
},
    get_data() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/get_config', formData, {}).then(function (response) {
        // console.log("cats is "+response.data.groups);
        // console.log("cats is "+items);

        var content_cats = response.data;
        // content_cats.languages.forEach(function (lang) {
        //   if (content_cats.configs.titles.filter(x => x.lng == lang.id).length == 0) {
        //     var obj = {}
        //     Object.assign(obj, content_cats.configs.title)
        //     obj.lng = lang.id;
        //     content_cats.configs.titles.push(obj)
        //   }
        //
        // })
        self.site_config = content_cats.configs
        self.close_reserve_time = self.site_config.close_reserve_time
        if(content_cats.links==null){
          self.links = {
            instagram:'',
            telegram:'',
            whatsapp:'',
            location:''
          }
        }else{
          self.links = JSON.parse(content_cats.links.data)
        }

        if(content_cats.notices==null){
          self.notices = {
            public_notice:'',
            cancel_notice:'',
          }
        }else{
          self.notices = content_cats.notices
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    update_settings() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/update_config";

      this.site_config.titles[0].right_icon = this.right_icon
      this.site_config.titles[0].left_icon = this.left_icon
      formData.append('site_config', JSON.stringify(this.site_config));
      formData.append('logo_file', this.logo_file);
      // formData.append('selected_currency', this.selected_currency);
      formData.append('favicon_file', this.favicon_file);
      formData.append('cover_file', this.cover_file);
      // formData.append('vat', this.vat);
      // formData.append('left_icon', this.left_icon);
      // formData.append('right_icon', this.right_icon);
      // formData.append('vat', this.vat);
      // formData.append('google_analytics', this.google_analytics);
      // formData.append('cache_time', this.cache_time);
      // formData.append('payment_type', this.payment_type);
      // formData.append('payment_time', this.payment_time);
      formData.append('close_reserve_time', this.close_reserve_time);


      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);


      }).catch(function (error) {

        console.log(error);
      });

    },
    update_links() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/update_links";

      formData.append('data', JSON.stringify(this.links));

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
      }).catch(function (error) {

        console.log(error);
      });

    },
    update_notices() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/update_notices";

      formData.append('public_notice', (this.notices.public_notice));
      formData.append('cancel_notice', (this.notices.cancel_notice));

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
      }).catch(function (error) {

        console.log(error);
      });

    },
    update_design() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/update_design";


      formData.append('data', JSON.stringify(this.design));


      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);


      }).catch(function (error) {

        console.log(error);
      });

    },
  }
}


</script>
<style scoped>
/* Responsive styles for mobile */
@media (max-width: 768px) {
  .c-card-body {
    padding: 1rem;
  }

  .c-tabs {
    overflow-x: auto;
  }

  .c-tab-content {
    padding: 1rem 0;
  }

  /* Ensure inputs are full width on mobile */
  .c-form-group {
    margin-bottom: 1rem;
  }

  /* Image selector responsive */
  ::v-deep .image-selector {
    margin-bottom: 1.5rem;
  }

  /* Button responsive */
  .c-btn {
    width: 100%;
    margin-top: 1rem;
  }
}

/* Tablet styles */
@media (min-width: 769px) and (max-width: 1024px) {
  .c-col-md-4 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>
